import React, { useState } from 'react';
import styles from "../../assets/scss/WebHomePagesscss/AppDownload.module.scss";
import DownloadPopup from './DownloadPopup';
import { toast } from 'react-toastify';

const AppDownload = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState('');
  const [selectedPlatform, setSelectedPlatform] = useState('');

  const platforms = [
    {
      name: 'Web App',
      type: 'webapp',
      requirement: 'For Desktop & Laptop',
      icon: '🌐',
     // url: 'https://devadmin.cropwork.in/download/desktop', //  web app  dev link
       url: 'https://testadmin.cropwork.in/download/desktop', //  web app  Test link
      //url: 'https://prod.cropwork.in/download/desktop', //  web app  Prod link

      badge: 'Highly Recommended'
    },
    {
      name: 'Android',
      type: 'android',
      requirement: 'Android 7 and newer',
      icon: '🤖',
      //   url: 'https://devadmin.cropwork.in/download/desktop', // Fallback or APK link if needed
      badge: 'Mobile App'
    },
    {
      name: 'Install App',
      type: 'app',
      requirement: 'For Mobile & Desktop',
      icon: '📲',
      isPWA: true,
      badge: 'Fast & Easy'
    },
  ];

  const handlePlatformClick = (platform) => {
    setSelectedUrl(platform.url || '');
    setSelectedPlatform(platform.type);
    setShowPopup(true);
  };

  const handleProceed = async (userInfo) => {
    // console.log('User info submitted:', userInfo);
    toast.success('Information submitted successfully!');
    setShowPopup(false);

    if (selectedPlatform === 'app') {
      if (window.deferredPrompt) {
        window.deferredPrompt.prompt();
        const { outcome } = await window.deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        window.deferredPrompt = null;
      } else {
        toast.info('App is already installed or your browser does not support installation.');
      }
      return;
    }

    if (selectedUrl) {
      window.open(selectedUrl, '_blank');
    }
  };

  const renderStoreButton = (platformName) => {
    switch (platformName) {
      case 'Windows':
        return (
          <>
            <div className={styles.buttonIcon}>⊞</div>
            <div className={styles.buttonText}>
              <div className={styles.buttonSubtext}>Get it from</div>
              <div className={styles.buttonMain}>Microsoft</div>
            </div>
          </>
        );
      case 'macOS':
      case 'iOS':
        return (
          <>
            <div className={styles.buttonIcon}>🍎</div>
            <div className={styles.buttonText}>
              <div className={styles.buttonSubtext}>Download on the</div>
              <div className={styles.buttonMain}>App Store</div>
            </div>
          </>
        );
      case 'Android':
        return (
          <>
            <div className={styles.buttonIcon}>▶</div>
            <div className={styles.buttonText}>
              <div className={styles.buttonSubtext}>GET IT ON</div>
              <div className={styles.buttonMain}>Google Play</div>
            </div>
          </>
        );
      case 'Web App':
        return (
          <>
            <div className={styles.buttonIcon}>🔗</div>
            <div className={styles.buttonText}>
              <div className={styles.buttonSubtext}>GO TO</div>
              <div className={styles.buttonMain}>Web App</div>
            </div>
          </>
        );
      case 'Install App':
        return (
          <>
            <div className={styles.buttonIcon}>📥</div>
            <div className={styles.buttonText}>
              <div className={styles.buttonSubtext}>CLICK TO</div>
              <div className={styles.buttonMain}>INSTALL</div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.appDownload}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          Download Now! On your Mobile and Desktop
        </h1>
        <p className={styles.subtitle}>
          Stay synced on Cropwork across all your devices, so you can pick up any data where you left off.
        </p>
      </div>

      <div className={styles.platformGrid}>
        {platforms.map((platform, index) => (
          <div
            key={index}
            className={`${styles.platformCard} ${styles[platform.name.toLowerCase().replace(/\s+/g, '')]}`}
            onClick={() => handlePlatformClick(platform)}
          >
            {platform.badge && (
              <div className={styles.badge}>
                {platform.badge}
              </div>
            )}

            <div className={styles.platformIcon}>
              {platform.icon}
            </div>

            <h3 className={styles.platformName}>
              {platform.name}
            </h3>

            <p className={styles.requirement}>
              {platform.requirement}
            </p>

            <div className={styles.downloadButton}>
              {renderStoreButton(platform.name)}
            </div>
          </div>
        ))}
      </div>

      {showPopup && (
        <DownloadPopup
          onClose={() => setShowPopup(false)}
          onProceed={handleProceed}
          type={selectedPlatform}
        />
      )}
    </div>
  );
};

export default AppDownload;




